<template>
    <div class="whitelabel-dropdown" :class="{ 'open': open, 'whitelabel-editing': editingWhitelabel }">
        <div class="container dropdown-inner">
            <a
                :href="editWhitelabel(whitelabel.id)"
                v-for="(whitelabel, index) in whitelabels"
                :key="index" class="btn btn-toggle"
                :class="{ 'active': activeWhitelabel === whitelabel.id }"
            >
                <i class="icons8-bookmark-ribbon"/> {{ whitelabel.subdomain }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'whitelabel-dropdown',

        props: {
            whitelabels: {
                type: Array,
                default() {
                    return [];
                }
            },

            open: {
                type: Boolean,
                default() {
                    return false;
                }
            },
        },

        computed: {
            activeWhitelabel() {
                let url = window.location.href;

                if (url.match(/\d+/)) {
                    return url.match(/\d+/)[0];
                }

                return null;
            },

            editingWhitelabel() {
                return Page.is('accountwhitelabeledit');
            },
        },

        methods: {
            editWhitelabel(id) {
                return this.$laroute.route('account.whitelabel.edit', {instance: id});
            },
        },
    }
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/grid.less";

    .whitelabel-dropdown {
        position: absolute;
        left: 0;
        right: 0;
        background-color: #ffffff;
        top: 129px;
        max-height: 0;
        overflow: hidden;
        z-index: 1;
        border-bottom: 0 solid #d3d3d3;
        box-shadow: -10px 6px 35px -5px #d3d3d3;
        transition: max-height ease-in 0.35s;

        &.whitelabel-editing {
            top: 193px;
            z-index: 3;
        }

        &.open {
            max-height: 200px;
            height: auto;
            transition: max-height ease-out 0.35s;
            border-bottom-width: 1px;
            overflow-y: scroll;
        }

        .dropdown-inner {
            padding: 30px 15px;

            .btn-toggle {
                .make-sm-column(3.65);
                .make-lg-column(2.75);
                font-size: 14px;
                font-weight: 600;
                color: #36383e;
                opacity: 0.58;
                padding: 0;
                margin-right: 20px;
                text-align: left;
                margin-bottom: 10px;

                &:hover {
                    opacity: 1;
                }

                i {
                     font-size: 19px;
                     vertical-align: middle;
                     font-weight: 800;
                     padding-right: 3px;
                }

                &:focus {
                    border: none;
                    box-shadow: none;
                }

                &.active {
                    border: none;
                    box-shadow: none;
                    opacity: 1;
                }
            }
        }
    }
</style>
